<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('processschema_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-vector-polyline</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-processschema-show">
      <v-img
        class = "ma-2"

        lazy-src="@/assets/imagenotfound.png"
        :key="componentKey"
        :src="imageurlItem"
      >
        <ImageForm
          ref="updateForm"
          :item="item"
          v-if="userHasAccess('processschema_edit')"
        />
          <v-btn
            color="secondary"
            small
            absolute
            bottom
            right
            @click="downloadItem()"
          >
            <v-icon>mdi-download-circle</v-icon>
          </v-btn>
      </v-img>
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('global.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>
              <td><strong>{{ $t('global.file') }}</strong></td>
              <td>
                <v-btn
                     v-if="item['file']"
                     color="secondary"
                     class=""
                     @click="downloadFileByObject(item)"
                   >
                     {{ $t('global.download') }}
                     <v-icon
                       right
                       dark
                     >mdi-download
                     </v-icon>
                   </v-btn>
              </td>

            </tr>
            <tr>
              <td><strong>{{ $t('global.updated') }}</strong></td>
              <td>
                {{ formatDateTime(item['updated'], 'long') }}
              </td>
              <td><strong>{{ $t('global.updatedby') }}</strong></td>
              <td>
                <span v-if="item['updatedBy']" > {{ item['updatedBy'].login }}</span>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('service.services') }}</strong></td>
              <td>
                <ul>
                  <li v-for="_item in item['services']" :key="_item.id">
                    {{ _item.name }}
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('profile.description') }}</strong></td>
              <td colspan="3">
                <span >{{ item['description'] }}</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';
import ImageForm from '../../components/ImageForm.vue';
import FileMixin from '../../mixins/FileMixin';

const servicePrefix = 'ProcessSchema';

export default {
  name: 'ProcessSchemaShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
      ImageForm
  },
  data() {
    return {

    };
  },
  mixins: [ShowMixin,AccessMixin,FileMixin],
  computed: {
    ...mapFields('processschema', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('processschema', ['find']),

  },
  methods: {
    ...mapActions('processschema', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),

  }
};
</script>
